// extracted by mini-css-extract-plugin
module.exports = {"donationModal":"DonationModal-module__donationModal___3MFpi"};